import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetCountdown: Widget = {
  type: WidgetType.countdown,
  noPadding: true,
  title: 'Countdown',
  minSize: 4,
  defaultSize: 14,
  icon: 'Apps',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      duration: { type: WidgetSettingType.number, title: 'Dauer des Countdown in Minuten', value: 30, min: 1, max: 240 },
      fontSize: { type: WidgetSettingType.number, title: 'Schriftgröße, Countdown', value: 48, min: 14, max: 128 },
      fontSizeLabel: { type: WidgetSettingType.number, title: 'Schriftgröße, Label', value: 28, min: 14, max: 128 },
      showTimeFormatLabel: { type: WidgetSettingType.checkbox, title: 'Zeitformat als Label anzeigen', checked: true },
      timeFormat: { type: WidgetSettingType.selectbox, title: 'Zeitformat', value: 'hh:mm:ss', options: [
        { label: 'hh:mm:ss', value: 'hh:mm:ss' },
        { label: 'hh:mm', value: 'hh:mm' },
        { label: 'mm:ss', value: 'mm:ss' }
      ]}
    }
  }
}

export default WidgetCountdown
